<article>
    <p id="code">404</p>
    <p>The page you have requested could not be found</p>
</article> 